import { render, staticRenderFns } from "./BudgetTransactionTable.vue?vue&type=template&id=6e99c2aa&"
import script from "./BudgetTransactionTable.vue?vue&type=script&lang=js&"
export * from "./BudgetTransactionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports